import { useContext } from 'react';

import SharedContext from '../sharedContext';

const useSharedContext = () => useContext(SharedContext);

export default useSharedContext;
